<template>
  <div>
    <v-dialog
      v-model="showRateDialog"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h5 green mb-3">
          <b class="white--text text--lighten-1">Successful file upload</b>
        </v-card-title>

        <v-card-text v-if="rateDialogMessage">
          <b>Total count</b>: {{ rateDialogMessage.totalCount }}
          <br>
          <b>Created count</b>: {{ rateDialogMessage.createdCount }}
          <br>
          <b>Updated count</b>: {{ rateDialogMessage.updatedCount }}
          <br>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            color="green darken-1"
            text
            @click="onClose"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'UploadRateDialog',
  props: {
    showRateDialog: {
      type: Boolean,
      default: () => false
    },
    rateDialogMessage: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    onClose () {
      this.$emit('on-close-dialog');
    },
    onHideRateDialog () {
      this.$emit("hide-upload-rate-dialog");
    }
  }
};
</script>
